import { ERROR_AUTOCLOSE_TIMEOUT_MS } from 'Constants';
import React, { useState } from 'react';

import projects from 'Api/projects';

import EditBorderButton from 'Components/Buttons/EditBorderButton';
import EditProjectDetails from 'Components/SingleProject/Modals/EditProjectDetailsModal';
import ErrorMessage from 'Components/UI/ErrorMessage';

import { useIsMounted } from 'Context';

import { getErrorMessageFromResponse, isValidResponse } from 'Utils';

export default function EditProjectDetailsBtn({
  afterAdd,
  disabled,
  projectId,
  projectData,
  projectCustomers,
  projectPartners,
  hasTestPackages,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [mainError, setMainError] = useState('');
  const mounted = useIsMounted();

  const saveProjectDetails = async (values) => {
    setSaveInProgress(true);
    let isSuccess = false;

    const projectEditData = {
      projectName: values.name,
      address: values.address,
      partners: values.partner,
      endCustomer: values.customer,
      users: projectData.users,
      totalSegments: projectData.totalSegments,
      description: values.description,
    };

    try {
      const res = await projects.updateOneProject(projectId, projectEditData);
      if (!isValidResponse(res)) {
        throw new Error(getErrorMessageFromResponse(res));
      }
      isSuccess = true;
    } catch (err) {
      console.log('Save Project details error: ', err);
      setMainError(err?.message || `Couldn't save project details`);
      setTimeout(() => setMainError(''), ERROR_AUTOCLOSE_TIMEOUT_MS);
    } finally {
      if (mounted.current) {
        setSaveInProgress(false);
      }
      if (isSuccess && typeof afterAdd === 'function') {
        if (mounted.current) {
          setModalOpen(false);
        }
        afterAdd();
      }
    }
  };

  return (
    <div>
      <EditBorderButton
        disableStyles={true}
        text="Edit project details"
        clickAction={() => setModalOpen(true)}
        extraBtnProps={{ disableFocusRipple: true, disabled }}
      />
      <EditProjectDetails
        projectData={projectData}
        projectCustomers={projectCustomers}
        projectPartners={projectPartners}
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        handleSubmit={(values) => saveProjectDetails(values)}
        actionsDisabled={saveInProgress}
        hasTestPackages={hasTestPackages}
      />
      {!!mainError && (
        <ErrorMessage
          message={mainError}
          handleCloseErrorAlert={() => setMainError(null)}
        />
      )}
    </div>
  );
}
